import { isNonEmployedJobType } from '@applyonline/shared';
import { EHomeStatus } from '@if/core/types';
export function transformApplicantExpensesToApi(expenses) {
    let ret = { ...expenses };
    Object.entries(ret).forEach(([key, value]) => {
        if (!value && value !== 0) {
            ret = { ...expenses, [key]: null };
        }
    });
    if (ret.homeFeeTypeId === EHomeStatus.OwnWithMortgage) {
        ret.mortgageMonthly = expenses.housingMonthly;
        ret.rentMonthly = null;
    }
    else {
        ret.rentMonthly = expenses.housingMonthly;
        ret.mortgageMonthly = null;
    }
    return ret;
}
export function transformCurrentJobs(jobs) {
    if (jobs && jobs.length > 0)
        return jobs.filter((x) => x.jobType !== null && !isNonEmployedJobType(x.jobType));
    return jobs ?? [];
}
export function transformOtherIncomes(other) {
    if (other.length > 0)
        return other.filter((x) => x.typeId);
    return other;
}
export function transformApplicantToApi(applicant) {
    return {
        ...applicant,
        expenses: transformApplicantExpensesToApi(applicant.spending),
        otherIncomes: transformOtherIncomes(applicant.otherIncomes),
        currentJobs: transformCurrentJobs(applicant.currentJobs),
    };
}
export function transformMerchantId(merchantId, prefix) {
    if (!merchantId.startsWith(`${prefix}*`))
        return `${prefix}*${merchantId}`;
    return merchantId;
}
